import { toast } from "react-toastify";
import { API_END_POINTS } from "../../../utils/config";
import JsonInterceptor from "../../../utils/JsonInterceptor";
import { errorMessage } from "../../../utils/custom";
import { scratchEventType } from "./type";

export const getScratchEventList = (body) => async (dispatch) => {
  try {
    dispatch({ type: scratchEventType.GET_SCRATCH_EVENT_REQUEST });
    let apiEndpoint = `${API_END_POINTS.getScratchEventListApi}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: scratchEventType.GET_SCRATCH_EVENT_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: scratchEventType.GET_SCRATCH_EVENT_FAIL, error: message });
  }
};
export const getScratchEventHistoryList = (body) => async (dispatch) => {
  try {
    dispatch({ type: scratchEventType.GET_USER_SCRATCH_EVENT_LIST_REQUEST });
    let apiEndpoint = `${API_END_POINTS.getHistoryOfScratchEventApi}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: scratchEventType.GET_USER_SCRATCH_EVENT_LIST_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: scratchEventType.GET_USER_SCRATCH_EVENT_LIST_FAIL, error: message });
  }
};

// export const updateSubscriptionStatus = (body) => async (dispatch) => {
//   try {
//     dispatch({ type: scratchEventType.UPDATE_STATUS_REQUEST });
//     let apiEndpoint = `${API_END_POINTS.updatePromoCodeStatus}`;
//     const { data } = await axiosForMultipartLocationAPI(true).post(`${apiEndpoint}`, body);
//     return dispatch({
//       type: scratchEventType.UPDATE_STATUS_SUCCESS,
//       payload: data
//     });
//   } catch (error) {
//     const message = error && error.data?.message ? error.data?.message : errorMessage();
//     toast.error(message);
//     return dispatch({ type: scratchEventType.UPDATE_STATUS_FAIL, error: message });
//   }
// };

export const createScratchEvent = (body) => async (dispatch) => {
  try {
    dispatch({ type: scratchEventType.CREATE_SCRATCH_EVENT_REQUEST });
    let apiEndpoint = `${API_END_POINTS.createScratchEventApi}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: scratchEventType.CREATE_SCRATCH_EVENT_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: scratchEventType.CREATE_SCRATCH_EVENT_FAIL, error: message });
  }
};

export const updateScratchEvent = (body, id) => async (dispatch) => {
  try {
    dispatch({ type: scratchEventType.UPDATE_SCRATCH_EVENT_REQUEST });
    let apiEndpoint = `${API_END_POINTS.updateScratchEventApi}`;
    const { data } = await JsonInterceptor.patch(`${apiEndpoint}/${id}`, body);
    return dispatch({
      type: scratchEventType.UPDATE_SCRATCH_EVENT_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: scratchEventType.UPDATE_SCRATCH_EVENT_FAIL, error: message });
  }
};

export const getSingleScratchEvent = (id) => async (dispatch) => {
  try {
    dispatch({ type: scratchEventType.GET_SINGLE_SCRATCH_EVENT_REQUEST });
    let apiEndpoint = `${API_END_POINTS.getSingleScratchEventApi}`;
    const { data } = await JsonInterceptor.get(`${apiEndpoint}/${id}`);
    return dispatch({
      type: scratchEventType.GET_SINGLE_SCRATCH_EVENT_SUCCESS,
      payload: data.data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({
      type: scratchEventType.GET_SINGLE_SCRATCH_EVENT_FAIL,
      error: message,
      statusCode: error?.status
    });
  }
};

export const deleteScratchEvent = (id) => async (dispatch) => {
  try {
    dispatch({ type: scratchEventType.DELETE_SINGLE_SCRATCH_EVENT_REQUEST });
    let apiEndpoint = `${API_END_POINTS.deleteScratchEventApi}`;
    const { data } = await JsonInterceptor.delete(`${apiEndpoint}/${id}`);
    return dispatch({
      type: scratchEventType.DELETE_SINGLE_SCRATCH_EVENT_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: scratchEventType.DELETE_SINGLE_SCRATCH_EVENT_FAIL, error: message });
  }
};

export const changeTab = (body) => (dispatch) => {
  return dispatch({
    type: scratchEventType.CHANGE_CUSTOMER_TAB,
    payload: body
  });
};
export const scratchEventDropdown = (body) => async (dispatch) => {
  try {
    dispatch({ type: scratchEventType.GET_SCRATCH_EVENT_DROPDOWN_REQUEST });
    let apiEndpoint = `${API_END_POINTS.getScratchEventDropdownApi}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: scratchEventType.GET_SCRATCH_EVENT_DROPDOWN_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: scratchEventType.GET_SCRATCH_EVENT_DROPDOWN_FAIL, error: message });
  }
};
